<template>
  <h3 class="app-subtitle">
    <slot></slot>
  </h3>
</template>

<script>
export default {
  name: 'AppSubtitle'
}
</script>

<style lang="scss">
.app-subtitle {
  padding-left: 15px;
  margin: 0;
  border-left: 2px solid $primary-color;
}
</style>
